import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function getEvent(object) {
  return request({
    cache: {
      // maxAge: 15 * 60 * 1000,
      key: req => {
        return req.url + JSON.stringify(object)
      }
      // exclude: {
      //   methods: ['put', 'patch', 'delete']
      // }
    },
    baseURL: getApiUrl(),
    url: '/event/get-event',
    method: 'post',
    data: object
  })
}

export function getEventDetail(event_id) {
  return request({
    cache: {
      // maxAge: 15 * 60 * 1000,
      key: req => {
        return req.url + event_id
      }
      // exclude: {
      //   methods: ['put', 'patch', 'delete']
      // }
    },
    baseURL: getApiUrl(),
    url: '/event/get-event-detail',
    method: 'post',
    data: { event_id: event_id }
  })
}

export function joinEvent(event_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/join-event',
    method: 'post',
    data: { event_id: event_id }
  })
}

export function joinEventV2(data) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/join-event-v2',
    method: 'post',
    data: data
  })
}

export function getEventTask() {
  return request({
    baseURL: getApiUrl(),
    url: '/event/get-task',
    method: 'post'
  })
}

export function getMemberTask(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/get-member-task',
    method: 'post',
    data: object
  })
}

export function receive(event_member_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/receive',
    method: 'post',
    data: { event_member_id: event_member_id }
  })
}
